import { useMemo } from "react";
import ICategory from "../../interfaces/ICategory";
import { useCategories } from "./useCategories";

export type IUseCategoryHook = (category: ICategory["id"]) => {
    data: ICategory;
    fetching: boolean;
    failed: boolean
}

export const useCategory: IUseCategoryHook = (categoryId) => {
    const { data: categoryList, fetching } = useCategories()
    const rawData = useMemo(() => categoryList.find(({ id }) => id === categoryId), [categoryList, categoryId]);

    if (!rawData) {
        //   throw Error("Cannot find category by id" + categoryId);
    }

    return useMemo(() => ({ data: rawData as any, fetching, failed: !rawData }), [rawData, fetching]);
};
